import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "src/@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuPortal,
    DropdownMenuSeparator,
    DropdownMenuShortcut,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import v2_actionFinalizarChat from "src/actions/v2/chats/v2_actionFinalizarChat";
import v2_actionDeletarLead from "src/actions/v2/crm/v2_actionDeletarLead";
import v2_actionEditarLead from "src/actions/v2/crm/v2_actionEditarLead";
import Iconify from "src/components/Iconify"
import { verifyRules } from "src/utils/functions";
import { toast } from 'src/@/components/ui/use-toast';


export function CardActionsMenu({ 
    card, 
    callbackRefreshLeads, 
    userId, 
    rules,
    onFinishWithMsg,
    onFinishWithoutMsg
}) {

    // onFinishWithMsg={() => handleFinalizarChat(chat._id, true, "Atendendo")}
    // onFinishWithoutMsg={() => handleFinalizarChat(chat._id, false, "Atendendo")}

    const [id, setId] = useState(card._id);
    const [isDelete, setIsDelete] = useState(false);
    const dispatch = useDispatch();


    async function handleEditLead(leadId, userId, action, scope) {
        try {
            let data = {
                action: action,
                scope
            };
            await v2_actionEditarLead(leadId, data, userId);

        } catch (error) {
            console.log('error', error)

        }

    }


    const handleFinishLead = async () => {
        await handleEditLead(card._id, userId, "finalizar_lead", {
            closed: true,
            data_finalizacao: new Date()
        });
        callbackRefreshLeads();
    }

    const handleDeleteLead = async () => {
        await v2_actionDeletarLead(id);
        callbackRefreshLeads()
    }

    const handleTopLead = async () => {
        await handleEditLead(card._id, userId, "top_lead", {
            data_modificacao: new Date()
        });
        callbackRefreshLeads();
    }

    const handleFinishChat = async (chatId, sendMessage, statusOrigin) => {
        let data = {
          userId: userId,
          sendMessage: sendMessage
        };
        try {
          await v2_actionFinalizarChat(chatId, data);
          toast("Chat finalizado com sucesso", {
            // description: "Sunday, December 03, 2023 at 9:00 AM",
            action: {
              label: "Fechar",
              onClick: () => console.log("Fechar"),
            }
          });
    
    
        } catch (error) {
            toast("Erro ao fechar chat", {
                // description: "Sunday, December 03, 2023 at 9:00 AM",
                action: {
                  label: "Fechar",
                  onClick: () => console.log("Fechar"),
                }
              });
        }
    
      };
    
    const handleUnlinkChat = async () => {
        await handleEditLead(card._id, userId, "unlink_chat", {
            whatsapp_chat_id: null
        });
        callbackRefreshLeads();
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button className="w-[2px] h-6" variant="ghost">
                    <Iconify icon="mage:dots-menu" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-30">
                {isDelete ? (
                    <div className="flex flex-col gap-2 p-2">
                        <Button
                            onClick={handleDeleteLead}
                            className="bg-red-500">
                            Confirmar
                        </Button>
                        <Button
                            onClick={() => {
                                setIsDelete(false);
                                setId(null);
                            }}
                            variant="outlined">
                            Cancelar
                        </Button>

                    </div>

                ) : (
                    <DropdownMenuGroup>
                        <div
                            className="text-red-500 text-[14px] px-2 py-1 hover:bg-red-100 cursor-pointer"
                            onClick={() => {
                                setIsDelete(true);
                                setId(card._id);
                            }}
                        >
                            <span>Excluir lead</span>
                        </div>
                        <DropdownMenuItem
                            onClick={handleFinishLead}
                        >
                            <span>Finalizar lead</span>
                        </DropdownMenuItem>

                        <DropdownMenuItem
                            onClick={handleTopLead}
                        >
                            <span>Colocar no topo</span>
                        </DropdownMenuItem>
                        {card.whatsapp && (
                            <DropdownMenuSub>
                                <DropdownMenuSubTrigger>
                                    <span>Chat</span>
                                </DropdownMenuSubTrigger>
                                <DropdownMenuPortal>
                                    <DropdownMenuSubContent>
                                        <DropdownMenuSub>
                                            <DropdownMenuSubTrigger>
                                                <span>Finalizar chat</span>
                                            </DropdownMenuSubTrigger>
                                            <DropdownMenuPortal>
                                                <DropdownMenuSubContent>
                                                <DropdownMenuItem onClick={() => handleFinishChat(card?.whatsapp?._id, true)}>
                                                        <span>Finalizar com mensagem</span>
                                                    </DropdownMenuItem>
                                                    {verifyRules(rules, "finalizar_sem_mensagem") && (
                                                        <DropdownMenuItem onClick={() => handleFinishChat(card?.whatsapp?._id, false)}>
                                                            <span>Finalizar sem mensagem</span>
                                                        </DropdownMenuItem>

                                                    )}
                                                </DropdownMenuSubContent>
                                            </DropdownMenuPortal>
                                        </DropdownMenuSub>
                                        <DropdownMenuItem
                                            onClick={handleUnlinkChat}
                                        >
                                            <span>Desvincular chat</span>
                                        </DropdownMenuItem>
                                    </DropdownMenuSubContent>
                                </DropdownMenuPortal>
                            </DropdownMenuSub>
                        )}


                    </DropdownMenuGroup>
                )}

            </DropdownMenuContent>
        </DropdownMenu>
    )
}
